import React from "react";
import moment from "moment-timezone";
import "moment/locale/pt-br";

function ConsultasCard({ imagem, especialidade, profissional, data, status }) {
  const handleClick = () => {
    alert("[Em breve] Detalhes de consulta");
  };

  const statusClasses = {
    Agendada: "bg-orange-500",
    Cancelada: "bg-red-500",
    Realizada: "bg-green-600",
  };

  // Converte UTC → Horário de Brasília
  const dataFormatada = data
    ? moment.utc(data).tz("America/Sao_Paulo").format("DD/MM/YYYY HH:mm")
    : "Data não informada";

  return (
    <div
      //onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyPress={handleClick}
      className="mt-5 h-[110px] rounded-lg border-2 border-solid border-gray-400 flex flex-row items-center cursor-pointer px-4 mx-auto"
    >
      <img
        src={
          imagem && imagem.trim() !== ""
            ? imagem
            : "https://www.gravatar.com/avatar/?d=mp&s=200"
        }
        alt={profissional}
        className="h-[65px] w-[65px] rounded-full border-[3px] border-solid border-[#003D42] flex-shrink-0"
      />
      <div className="ml-4 flex flex-col justify-center">
        <div className="text-[16px] font-extrabold text-[#003D42] mb-1">
          {especialidade}
        </div>
        <div className="text-[14px] font-medium mb-0.5">{profissional}</div>
        <div className="text-[14px] font-medium">Data: {dataFormatada}</div>
      </div>
      <div className="ml-auto">
        <div
          className={`min-w-[75px] h-[35px] px-2 mr-1 rounded flex items-center justify-center font-bold text-white text-center select-none ${
            statusClasses[status] || statusClasses["Realizada"]
          }`}
        >
          {status}
        </div>
      </div>
    </div>
  );
}

export default ConsultasCard;
